import * as CustomDataConstant from "../../components/Constants/CustomDataConstant";

export const getSearchIndexPreferences = (customUserData) => {
    let indexPreferences = [];

    if (customUserData && customUserData.customData && customUserData.customData.hasOwnProperty(CustomDataConstant.SearchIndexPreferencesKey)) {
        indexPreferences = customUserData.customData[CustomDataConstant.SearchIndexPreferencesKey];
    }

    return indexPreferences;
}

export const updateSearchIndexPreference = (customUserData, searchPreferences) => {
    let updatedCustomData = { ...customUserData?.customData };

    if (searchPreferences && searchPreferences.length > 0) {
        updatedCustomData[CustomDataConstant.SearchIndexPreferencesKey] = searchPreferences;
    } else {//remove key
        updatedCustomData = removeSearchIndexPreference(updatedCustomData);
    }

    return updatedCustomData;
}

export const removeSearchIndexPreference = (customData) => {
    let clearedCustomData = { ...customData };
    delete clearedCustomData[CustomDataConstant.SearchIndexPreferencesKey];
    return clearedCustomData;
}

export const updateThemePreferences = (customUserData, theme) => {
    let updatedCustomData = { ...customUserData?.customData };   
    updatedCustomData[CustomDataConstant.ThemePreferencesKey] = theme;
    return updatedCustomData;
}